'use client';

import { useTranslations } from 'next-intl';
import { useGetPageUrl } from '@/schema/useGetPageUrl';
import { Link } from '@/shared/i18n/navigation';
import { Icon } from '@/shared/ui/icon';
import './cart-empty.scss';

export const CartEmpty = () => {
    const t = useTranslations();
    const getPageUrl = useGetPageUrl();

    return (
        <div className="cart-empty">
            <div className="cart-empty__icon">
                <Icon name="cart" width={40} height={47} />
            </div>
            <p className="cart-empty__text">
                {t.rich('CART_EMPTY.TEXT', {
                    link: (chunks) => (
                        <Link href={getPageUrl('home')!} className="cart-empty__link">
                            {chunks}
                        </Link>
                    ),
                })}
            </p>
        </div>
    );
};
